import { defineComponent as r, createBlock as a, openBlock as c, unref as l, mergeProps as p, withCtx as v, createElementVNode as o } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconLockLocked",
  __name: "IconLockLocked",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (m, e) => (c(), a(l(d), p(n, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        o("path", { d: "M12 12.25A.75.75 0 0 1 12.75 13v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 12 12.25" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M7.75 8.25V7.2c0-2.243 1.967-3.95 4.25-3.95s4.25 1.707 4.25 3.95v1.05h.25a3.25 3.25 0 0 1 3.25 3.25v6a3.25 3.25 0 0 1-3.25 3.25h-9a3.25 3.25 0 0 1-3.25-3.25v-6A3.25 3.25 0 0 1 7.5 8.25h.25m1.5-1.05c0-1.291 1.166-2.45 2.75-2.45s2.75 1.159 2.75 2.45v1.05h-5.5V7.2m7.25 2.55a1.75 1.75 0 0 1 1.75 1.75v6a1.75 1.75 0 0 1-1.75 1.75h-9a1.75 1.75 0 0 1-1.75-1.75v-6A1.75 1.75 0 0 1 7.5 9.75h9",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
